import { PRO_SECTION_ID } from './constants'

const CORRECTION_WINDOW_MS = 3000
const USER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown'] as const

// Call at scroll time, not mount time, so a mid-session preference change is honored.
const scrollBehavior = (): ScrollBehavior =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth'

export const scrollToProSection = () => {
  const section = document.getElementById(PRO_SECTION_ID)
  if (!section) return

  section.scrollIntoView({ behavior: scrollBehavior(), block: 'start' })

  // Sections above can still be loading; a layout shift aborts a smooth scroll
  // short of the target. Land on it once that scroll settles, unless the
  // visitor took over scrolling or the window passed.
  const stopCorrecting = () => {
    window.clearTimeout(timeout)
    window.removeEventListener('scrollend', land)
    USER_SCROLL_EVENTS.forEach((type) =>
      window.removeEventListener(type, stopCorrecting),
    )
  }
  const land = () => {
    stopCorrecting()
    section.scrollIntoView({ block: 'start' })
  }
  const timeout = window.setTimeout(stopCorrecting, CORRECTION_WINDOW_MS)

  window.addEventListener('scrollend', land)
  USER_SCROLL_EVENTS.forEach((type) =>
    window.addEventListener(type, stopCorrecting, { passive: true }),
  )
}
